import { useCallback, useEffect, useState } from "react";

import { getMe, getShifts } from "src/api/client";
import type { Shift } from "src/api/types";

export function useShift(token: string, onError?: (message: string) => void) {
  const [activeShift, setActiveShift] = useState<Shift | null>(null);
  const [activeShifts, setActiveShifts] = useState<Shift[]>([]);

  const load = useCallback((): Promise<void> => {
    return Promise.all([getMe(token), getShifts(token)]).then(([me, shifts]) => {
      const active = shifts.filter((s) => s.status === "active");
      setActiveShifts(active);
      setActiveShift(active.find((s) => s.staff_id === me.id) ?? null);
    });
  }, [token]);

  useEffect(() => {
    let cancelled = false;
    load().catch(() => {
      if (cancelled) return;
      onError?.("Failed to load shift status. Please refresh.");
    });
    return () => {
      cancelled = true;
    };
  }, [load, onError]);

  return { activeShift, setActiveShift, activeShifts, refetchShifts: () => void load() };
}
